import React from 'react';
import {
  RoadmapDeliverableDashboardChart,
} from 'Views/Dashboard/RoadmapDeliverableDashboardChart/RoadmapDeliverableDashboardChart';
import DataContainer from 'Components/UI/DataContainer';
import { useDashboardContext } from 'Views/Dashboard/DashboardContext';
import useRelationship from 'Hooks/useRelationship';
import fr from 'facet-rest';
import Skeleton from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Skeleton';
import { FDContentContainer } from '@facet-wealth/design';

const RoadmapDeliverableDashboardChartContainer = () => {
  const { clientDashboardResource } = useDashboardContext();
  const {
    isInitializing,
    loadingError,
    collection,
  } = useRelationship(clientDashboardResource.relationship(fr.relationships.roadmapDeliverableChart.name));

  const resource = collection?.resources().head();

  return (
    <DataContainer
      component={RoadmapDeliverableDashboardChart}
      loading={isInitializing}
      componentProps={{
        resource,
      }}
      loadingError={loadingError}
      skeleton={() => (
        <FDContentContainer maxWidth="xl">
          <Skeleton
            style={{ borderRadius: '16px' }}
            variant={'rect'}
            width={'100%'}
            height={'50vh'}
          />
        </FDContentContainer>
      )}
    />
  );
};

export { RoadmapDeliverableDashboardChartContainer };
